import Container from '@mui/material/Container'
import { policies } from '../../RacesData/policies'

const POLICIES_MAP = {
  default: policies
}

export default function Policies ({ eventDetails }) {
  const policiesKey = eventDetails?.policiesKey || 'default'
  const content = POLICIES_MAP[policiesKey]
  return (
    <Container maxWidth='xl'>
      {content}
    </Container>
  )
}
